export const failureHash = {
    GPT_POLICY_VIOLATION: "API__SMP__GPT__EDIT__GPT_POLICY_VIOLATION",
};
//# sourceMappingURL=edit.static.js.map